// Demo data for the 5 BetaNXT Proxy Ops ideas. All dates use demo date 2026-09-27.

export const TODAY_LABEL = '2026-09-27';

export interface DemoJob {
  jobId: string;
  issuer: string;
  cusip: string;
  solicitor: string;
  solicitorEmail: string;
  meeting: string; // ISO date
  market: 'US' | 'CA';
  material: string;
  ordered?: number;
  received?: number;
  rdqSets?: number;
  printSets?: number;
}

export const DEMO_JOBS: Record<string, DemoJob> = {
  '4010016': { jobId: '4010016', issuer: 'Cormorant Energy Partners',   cusip: '21988P108', solicitor: 'Broadridge ICS',        solicitorEmail: 'solicitor@broadridge.com',          meeting: '2026-10-08', market: 'US', material: 'Notice / Proxy Statement', ordered: 7, received: 4 },
  '4010070': { jobId: '4010070', issuer: 'Bellcrest Retail Holdings',    cusip: '07816C208', solicitor: 'Broadridge ICS',        solicitorEmail: 'solicitor@broadridge.com',          meeting: '2026-10-09', market: 'US', material: 'Proxy Statement', ordered: 12, received: 9 },
  '4010011': { jobId: '4010011', issuer: 'Northstar Agri Corp',          cusip: '66724R109', solicitor: 'Alliance Advisors',     solicitorEmail: 'ops@allianceadvisors.com',          meeting: '2026-10-04', market: 'US', material: 'Notice / Proxy Statement', ordered: 5, received: 2, printSets: 5 },
  '3060011': { jobId: '3060011', issuer: 'Phas Tech Holding Ltd',        cusip: '71742Y108', solicitor: 'Georgeson',             solicitorEmail: 'proxy@georgeson.com',               meeting: '2026-10-18', market: 'US', material: 'Proxy Statement', ordered: 8, received: 6 },
  '3060010': { jobId: '3060010', issuer: 'Ballston Spa Bancorp',         cusip: '058731106', solicitor: 'Broadridge ICS',        solicitorEmail: 'solicitor@broadridge.com',          meeting: '2026-10-19', market: 'US', material: 'Proxy Statement', ordered: 6, received: 4 },
  '9100020': { jobId: '9100020', issuer: 'Hartwell Pharmaceuticals',     cusip: '41783K105', solicitor: 'Georgeson',             solicitorEmail: 'proxy@georgeson.com',               meeting: '2026-10-21', market: 'US', material: 'Proxy Statement', rdqSets: 2400 },
  '9100024': { jobId: '9100024', issuer: 'Palisade Consumer Brands',     cusip: '69608A108', solicitor: 'Mediant Communications', solicitorEmail: 'jobs@mediant.com',                 meeting: '2026-10-17', market: 'US', material: 'Proxy Statement', rdqSets: 1800 },
  '9100021': { jobId: '9100021', issuer: 'Coastal Marine Terminals',     cusip: '19059P108', solicitor: 'Morrow Sodali',         solicitorEmail: 'info@investor.morrowsodali.com',    meeting: '2026-10-16', market: 'US', material: 'Proxy Statement', rdqSets: 960 },
  '9100022': { jobId: '9100022', issuer: 'Granite Peak Mining',          cusip: '38741P104', solicitor: 'D.F. King',             solicitorEmail: 'proxy@dfking.com',                  meeting: '2026-10-06', market: 'US', material: 'Proxy Statement', printSets: 40 },
  '4010015': { jobId: '4010015', issuer: 'Thackeray Grain Cooperative',  cusip: '88320G107', solicitor: 'Georgeson',             solicitorEmail: 'proxy@georgeson.com',               meeting: '2026-10-07', market: 'US', material: 'Proxy Statement', printSets: 20 },
  '3025905': { jobId: '3025905', issuer: 'Laurentian Bank of Canada',    cusip: '51925D106', solicitor: 'Broadridge Canada',     solicitorEmail: 'ca.solicitor@broadridge.com',       meeting: '2026-10-02', market: 'CA', material: 'Notice / Circular' },
  '4010009': { jobId: '4010009', issuer: 'Kestrel Transit Authority',    cusip: '49262L108', solicitor: 'Broadridge ICS',        solicitorEmail: 'solicitor@broadridge.com',          meeting: '2026-10-01', market: 'US', material: 'Proxy Statement', printSets: 30 },
  '3021919': { jobId: '3021919', issuer: 'Powell Industries Inc',        cusip: '739128106', solicitor: 'Broadridge ICS',        solicitorEmail: 'solicitor@broadridge.com',          meeting: '2026-10-15', market: 'US', material: 'Proxy Statement' },
  '920001':  { jobId: '920001',  issuer: 'Kessler Foods International',  cusip: '49271M100', solicitor: 'Okapi Partners',        solicitorEmail: 'contest@okapipartners.com',         meeting: '2026-10-03', market: 'US', material: 'Contest authorization' },
  '920002':  { jobId: '920002',  issuer: 'Marchbanks Industrial Group',  cusip: '56658P104', solicitor: 'Innisfree M&A',         solicitorEmail: 'contest@innisfreema.com',           meeting: '2026-10-05', market: 'US', material: 'Contest authorization' },
  '3040869': { jobId: '3040869', issuer: 'Water Corp',                   cusip: '94106L109', solicitor: 'Kingsdale Advisors',    solicitorEmail: 'proxy@kingsdaleadvisors.com',       meeting: '2026-10-20', market: 'US', material: 'Proxy Statement', rdqSets: 2100 },
};

export type FilingStatus = 'ingested' | 'pending' | 'running';

export interface DemoFiling {
  jobId: string;
  source: 'SEC EDGAR' | 'SEDAR';
  docType: string;
  pages: number;
  status: FilingStatus;
  note: string;
  daysLeft: number;
}

export const DEMO_FILINGS: DemoFiling[] = [
  { jobId: '3021919', source: 'SEC EDGAR', docType: 'DEF 14A',       pages: 86, status: 'ingested', note: 'Proxy Statement · 86 pages · in verifications@', daysLeft: 18 },
  { jobId: '3025905', source: 'SEDAR',     docType: 'Notice / Circular', pages: 40, status: 'ingested', note: 'Circular · 40 pages · in verifications@',    daysLeft: 5 },
  { jobId: '4010009', source: 'SEC EDGAR', docType: 'DEF 14A',       pages: 64, status: 'pending',  note: 'Not on file', daysLeft: 4 },
  { jobId: '9100022', source: 'SEC EDGAR', docType: 'DEF 14A',       pages: 48, status: 'pending',  note: 'Not on file', daysLeft: 9 },
  { jobId: '4010015', source: 'SEC EDGAR', docType: 'DEFA14A',       pages: 22, status: 'pending',  note: 'Not on file', daysLeft: 10 },
];

export type CampaignType   = 'shortage' | 'yellow' | 'red';
export type CampaignStatus = 'ready' | 'scheduled' | 'blocked';

export interface DemoCampaign {
  id: string;
  jobId: string;
  type: CampaignType;
  status: CampaignStatus;
  scheduledLabel?: string;
  sync?: { control: string; detail: string } | null;
  sentAt?: string;
}

export const DEMO_CAMPAIGNS: DemoCampaign[] = [
  { id: 'c-4010016', jobId: '4010016', type: 'shortage', status: 'ready' },
  { id: 'c-4010070', jobId: '4010070', type: 'shortage', status: 'scheduled', scheduledLabel: '14:00 ET' },
  { id: 'c-4010011', jobId: '4010011', type: 'shortage', status: 'ready' },
  { id: 'c-3060011', jobId: '3060011', type: 'shortage', status: 'ready' },
  { id: 'c-3060010', jobId: '3060010', type: 'shortage', status: 'ready' },
  { id: 'c-9100020', jobId: '9100020', type: 'yellow',   status: 'scheduled', scheduledLabel: '14:00 ET' },
  { id: 'c-9100024', jobId: '9100024', type: 'yellow',   status: 'ready' },
  { id: 'c-9100021', jobId: '9100021', type: 'yellow',   status: 'blocked' },
  { id: 'c-9100022', jobId: '9100022', type: 'red',      status: 'ready' },
  { id: 'c-4010015', jobId: '4010015', type: 'red',      status: 'ready' },
  { id: 'c-3025905', jobId: '3025905', type: 'red',      status: 'ready',  sync: { control: 'BR-229184', detail: 'Release not posted in RICS' } },
  { id: 'c-4010009', jobId: '4010009', type: 'red',      status: 'ready' },
];

export interface DemoRdqRow {
  holder: string;
  kind: string;
  sets: string;
  keep?: boolean;
  reason?: string;
}

export const DEMO_RDQ_ROWS: DemoRdqRow[] = [
  { holder: 'Jane Smith',            kind: 'Registered',  sets: '400',  keep: true },
  { holder: 'Northwind NOBO block',  kind: 'NOBO',        sets: '900',  reason: 'Excluded · NOBO' },
  { holder: 'Estate of R. Jones',    kind: 'Bankruptcy',  sets: '120',  reason: 'Excluded · Bankruptcy' },
  { holder: 'Wei Chen',              kind: 'Beneficial',  sets: '640',  keep: true },
  { holder: 'SRA omnibus',           kind: 'SRA',         sets: '300',  reason: 'Excluded · SRA' },
  { holder: 'A. Patel',             kind: 'Beneficial',  sets: '800',  keep: true },
  { holder: 'Prior job 3031001',     kind: 'Green',       sets: '—',    reason: 'Purged · Green status' },
  { holder: 'Prior job 3030888',     kind: 'Green',       sets: '—',    reason: 'Purged · Green status' },
];

export const DEMO_AUDIT_LOG = [
  { time: '04:02', text: 'Ace classified the shared inbox and held 2 messages in Exceptions.' },
  { time: '03:41', text: 'Auto-ingested Powell Industries DEF 14A (86 pages) and the Laurentian Bank circular (40 pages) into verifications@.' },
  { time: '03:16', text: 'Built today\'s Yellow, Red, and Shortage queues from meeting dates in MIC.' },
];

// Compute days from TODAY_LABEL to a meeting date string
export function daysUntil(meeting: string): number {
  const today = new Date('2026-09-27T00:00:00');
  const meet  = new Date(meeting + 'T00:00:00');
  return Math.round((meet.getTime() - today.getTime()) / 86400000);
}

export type DeadlineWindow = 'Abort' | 'Email-only' | 'POD' | 'Red' | 'Yellow' | 'Green';

export function deadlineWindow(days: number, hasFile: boolean): DeadlineWindow {
  if (days < 5)  return 'Abort';
  if (days === 5) return 'Email-only';
  if (days <= 10 && !hasFile) return 'POD';
  if (days <= 10) return 'Red';
  if (days <= 18) return 'Yellow';
  return 'Green';
}
